import { useState, useEffect } from "react";
import Modal from "react-modal";
import "./style.css";

import Sidebar from "../../componente/sidebar/index.jsx";
import PageHeader from "../../componente/topbar/index.jsx";

import { useCrud } from "../../hooks/useCrud";
import { useAppContext } from "../../pages/context/AppContext.jsx";

import { toast } from "react-hot-toast";

Modal.setAppElement("#root");

function Pessoa() {

  const { codusuario } = useAppContext();

  /* ==============================
     IMPORTAÇÃO DINÂMICA (CRA)
  ============================== */

  const importarImagens = () => {

    const contexto = require.context(
      "../../assets/pessoa",
      false,
      /\.png$/
    );

    const imagens = {};

    contexto.keys().forEach((key) => {

      const nomeArquivo = key
        .replace("./", "")
        .replace(".png", "");

      const index = parseInt(nomeArquivo) - 1;

      imagens[index] = contexto(key);

    });

    return imagens;

  };

  const imagens = importarImagens();

  /* ============================== */

  const [sidebarAberto, setSidebarAberto] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editando, setEditando] = useState(null);

  const {
    dados: pessoas,
    loading,
    error,
    listar,
    buscarUm,
    criar,
    editar,
    excluir
  } = useCrud({
    rotaLista: "v1/pessoa",
    rotaUm: "v1/pessoaum"
  });

  useEffect(() => {
    listar({ codusuario });
  }, [codusuario]);

  const [form, setForm] = useState({
    indexpessoa: 0,
    pessoa: ""
  });

  const abrirModal = async (item = null) => {

    if (item) {

      const dados = await buscarUm({
        codpessoa: item.codpessoa,
        codusuario
      });

      setEditando(dados.codpessoa);

      setForm({
        codpessoa: dados.codpessoa,
        indexpessoa: dados.indexpessoa,
        pessoa: dados.pessoa
      });

    } else {

      setEditando(null);

      setForm({
        indexpessoa: 0,
        pessoa: ""
      });

    }

    setModalOpen(true);

  };

  const salvar = async () => {

    const dt1 = new Date();

    const date1 =
      dt1.getFullYear() +
      "-" +
      (dt1.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt1.getDate().toString().padStart(2, "0");

    const time1 =
      dt1.getHours().toString().padStart(2, "0") +
      ":" +
      dt1.getMinutes().toString().padStart(2, "0");

    if (!form.pessoa) {
      toast.error("Informe o nome da pessoa");
      return;
    }

    if (editando) {

      await editar({
        dtalteracao: `${date1}T${time1}`,
        codpessoa: editando,
        indexpessoa: form.indexpessoa,
        pessoa: form.pessoa
      });

    } else {

      await criar({
        dtalteracao: `${date1}T${time1}`,
        codusuario,
        indexpessoa: form.indexpessoa,
        pessoa: form.pessoa
      });

    }

    setModalOpen(false);

  };

  const excluirPessoa = async (codpessoa) => {

    if (!window.confirm("Deseja realmente excluir esta pessoa?")) return;

    await excluir({
      codpessoa,
      codusuario
    });

  };

  return (
    <>
      <PageHeader
        titulo="Pessoas"
        subtitulo="Responsáveis pela movimentação financeira"
        abrirMenu={() => setSidebarAberto(true)}

        botaoAdicionar
        textoAdicionar="Nova Pessoa"
        onAdicionar={() => abrirModal()}
      />

      <div className="pessoa-container">

        <Sidebar
          aberto={sidebarAberto}
          fechar={() => setSidebarAberto(false)}
        />

        <div className="pessoa-wrapper">

          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          ) : (

            <div className="pessoa-list">

              {pessoas.map((p) => (

                <div
                  key={p.codpessoa}
                  className="pessoa-card"
                  onClick={() => abrirModal(p)}
                >

                  <div className="pessoa-left">

                    <img
                      src={imagens[p.indexpessoa] ?? imagens[0]}
                      alt=""
                    />

                    <strong>{p.pessoa}</strong>

                  </div>

                  <button
                    className="btn-delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      excluirPessoa(p.codpessoa);
                    }}
                  >
                    Excluir
                  </button>

                </div>

              ))}

            </div>

          )}

          {/* MODAL */}

          <Modal
            isOpen={modalOpen}
            onRequestClose={() => setModalOpen(false)}
            className="modal-content"
            overlayClassName="modal-overlay"
          >

            <div className="modal-header">
              <h3>
                {editando ? "Editar Pessoa" : "Nova Pessoa"}
              </h3>
            </div>

            <div className="modal-body">

              <div className="modal-imagens">

                {Object.keys(imagens).map((i) => (

                  <img
                    key={i}
                    src={imagens[i]}
                    alt=""
                    className={
                      form.indexpessoa === parseInt(i)
                        ? "ativo"
                        : ""
                    }
                    onClick={() =>
                      setForm({
                        ...form,
                        indexpessoa: parseInt(i)
                      })
                    }
                  />

                ))}

              </div>

              <input
                type="text"
                placeholder="Nome da pessoa"
                value={form.pessoa}
                onChange={(e) =>
                  setForm({
                    ...form,
                    pessoa: e.target.value
                  })
                }
              />

            </div>

            <div className="modal-footer">

              <button
                className="btn-cancelar"
                onClick={() => setModalOpen(false)}
              >
                Cancelar
              </button>

              <button
                className="btn-salvar"
                onClick={salvar}
              >
                Salvar
              </button>

            </div>

          </Modal>

        </div>

      </div>
    </>
  );
}

export default Pessoa;